import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _forEach from 'lodash/forEach';
import _keys from 'lodash/keys';

import { AppContext } from 'commons-ui';

import useService from '../../../useService';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestUpdateApkVersionInfo, requestUploadApk } = useService();

	const updateApkVersionInfo = async (updatedData: any) => {
		setShowLoader(true);

		try {
			const formData = new FormData();
			_forEach(_keys(updatedData), (key: string) => {
				formData.append(key, updatedData[key]);
			});
			const result = await requestUploadApk(formData);
			const apkLinkUrl = _get(result, ['data', 'apkLinkUrl']);

			const updateApkFinalData = { ...updatedData, apkLinkUrl };

			await requestUpdateApkVersionInfo(updateApkFinalData);
			showAlert('Apk Version Updated');
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: any) => {
		updateApkVersionInfo(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: _get(location, ['state', 'rowData']),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
